import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Spinner, Layout } from "../../components";
import { getPolls } from '../../services/polls.service';
import { FormNewPoll } from './polls.new';
import { Link } from "react-router-dom";
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import moment from "moment";
import AddIcon from '@material-ui/icons/Add';
import { Paper, Table, TableCell, Button, TableHead, TableRow, TableBody, Grid } from "@material-ui/core";

export const Polls = ()=> {

    const [modalOpen, setModalOpen] = useState(false);

    const [polls, setPolls] = useState();
    const [loading, setLoading] = useState(false);
    const [lastId, setLastId] = useState();
    const dispatch = useDispatch();

    useEffect(()=> {

        const getAllPolls = async ()=> {

            setLoading(true);

            const response = await getPolls();

            console.log("response", response);
            
            setLastId(response[0].id);
            setPolls(response);
            setLoading(false);
        };

        getAllPolls();
    }, [dispatch])

    const user = useSelector(store => store.user);

    return (
        <Layout>
            <Grid container>
                <Grid item md={10}>
                    <h1>Enquetes</h1>
                </Grid>
                <Grid item md={2} style={{ paddingTop: "20px", textAlign: "right" }}>
                    <Button startIcon={<AddIcon />} variant="contained" color="primary" onClick={ ()=> setModalOpen(true) } >Adicionar</Button>
                </Grid>
                <Grid item md={12}>
                    <Paper>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                <TableCell>Título</TableCell>
                                <TableCell align="center">Votos</TableCell>
                                <TableCell align="center">Opções</TableCell>
                                <TableCell align="center">Data</TableCell>
                                <TableCell align="center">Publicada</TableCell>
                                <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { loading
                                ? <TableRow><TableCell><Spinner /></TableCell></TableRow>
                                : polls && polls.map( (poll, i) => (
                                    <TableRow key={i}>
                                        <TableCell component="th" scope="row">
                                        <Link to={`/edit-poll/${poll.id}`}>
                                            { poll.title }
                                        </Link>
                                        </TableCell>
                                        <TableCell align="center"> { poll.totalVotes } </TableCell>
                                        <TableCell align="center"> { poll.options.length } </TableCell>
                                        <TableCell align="center"> {moment(poll.createdAt).format("DD/MM")} </TableCell>
                                        <TableCell align="center">
                                            { poll.published ? <CheckIcon color="primary" /> : <CloseIcon color="secondary" />}
                                        </TableCell>
                                        <TableCell align="center">
                                        {user.email === 'luizfernandocad@gmail.com' && <DeleteIcon color="primary" />}
                                        </TableCell>
                                    </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
            </Grid>
            <FormNewPoll open={ modalOpen } setOpen={ setModalOpen } lastId={ lastId }/>
        </Layout>
    )
}


export default Polls;